import { motion } from 'framer-motion';
import { motionVariants } from '../Common/GlobalVars';


const BlurMinProduct = () => {

  return (
    <motion.div
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true }}
      variants={motionVariants}
      className="rounded shadow-[0_5px_15px_-5px_rgb(0,0,0,0.1)]"
    >
      <div className="rounded bg-gradient-to-r from-blurProductStartBg to-blurProductEndBg blur-product-img">
        <div className="relative pt-[100%] block">
          <div className="absolute top-0 left-0 object-contain w-full h-full align-bottom rounded-t">
          </div>
        </div>
        <div className="px-2 pb-4 rounded-b">
          <p className="h-8 pt-1 mb-2 text-xs font-medium text-black capitalize line-clamp-2 text-ellipsis font-poppins">
            &nbsp;
          </p>
          <div className="flex justify-between">
            <div className="text-sm font-poppins">
              &nbsp;
            </div>
            <button className="z-10 p-1 cursor-pointer w-fit h-fit">
              &nbsp;
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default BlurMinProduct
